
import React, { memo, useContext } from 'react';
import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { ModalContext } from 'src/contexts/modal-context';
import { SearchGroup } from '@components/input';
import { IFilterSelectItems } from '@redux/slices/order';
import { ExportButton } from '@styles/components/button';
import { translate } from '@components/i18n';
import { Option, Select } from '@styles/components/form'
import FormItemLabel from 'antd/lib/form/FormItemLabel';
import { EditModal } from './edit-modal';

export const Header: React.FC = memo(() => {
    const dispatch = useDispatch();
    const modalContext = useContext(ModalContext);

    const add = (): void => {
        modalContext.setIsOpen(true, <EditModal />, {
            title: translate('general.registerItem'),
            width: '40%',
        });
    };

    return (
        <Col>
            <Row style={{ marginTop: 20 }} align="middle">
                <Col span={24}>
                    <Row justify="end" align="middle">
                        <Col span={14}>
                          <Row justify="end">
                                <Col span={5}>
                                    <ExportButton onClick={add}>
                                        {translate('forms.buttons.addNew')}
                                    </ExportButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
});
